import type { Dispatch, SetStateAction } from "react";
import type { WordPressSiteOption } from "@/lib/composerCore";
import type { EditorState } from "./connectorManagerHelpers";
import { WebhookFields } from "./connectorFields/WebhookFields";
import { KitFields } from "./connectorFields/KitFields";
import { BentoFields } from "./connectorFields/BentoFields";
import { WordPressFields } from "./connectorFields/WordPressFields";
import { WordPressSelfHostedFields } from "./connectorFields/WordPressSelfHostedFields";
import { GhostFields } from "./connectorFields/GhostFields";
import { SubstackUnofficialFields } from "./connectorFields/SubstackUnofficialFields";
import { BeehiivFields } from "./connectorFields/BeehiivFields";
import { ButtondownFields } from "./connectorFields/ButtondownFields";
// Bluesky/Mastodon fields removed 2026-07-03.
import { EmailFields } from "./connectorFields/EmailFields";

type Props = {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
  wpStatusLoading: boolean;
  wpLinked: boolean | null;
  wpSites: WordPressSiteOption[] | null;
  wpSitesLoading: boolean;
  wpSitesError: string | null;
  loadWpSites: () => void | Promise<void>;
  addRecipientFromDraft: () => void;
  removeRecipient: (email: string) => void;
};

export const ConnectorEditorFields = (props: Props) => {
  const { editor, setEditor } = props;
  switch (editor.connectorType) {
    case "webhook":
      return <WebhookFields editor={editor} setEditor={setEditor} />;
    case "kit":
      return <KitFields editor={editor} setEditor={setEditor} />;
    case "bento":
      return <BentoFields editor={editor} setEditor={setEditor} />;
    case "wordpress":
      return (
        <WordPressFields
          editor={editor}
          setEditor={setEditor}
          wpStatusLoading={props.wpStatusLoading}
          wpLinked={props.wpLinked}
          wpSites={props.wpSites}
          wpSitesLoading={props.wpSitesLoading}
          wpSitesError={props.wpSitesError}
          loadWpSites={props.loadWpSites}
        />
      );
    case "wordpress_self_hosted":
      return <WordPressSelfHostedFields editor={editor} setEditor={setEditor} />;
    case "ghost":
      return <GhostFields editor={editor} setEditor={setEditor} />;
    case "substack_unofficial":
      return <SubstackUnofficialFields editor={editor} setEditor={setEditor} />;
    case "beehiiv":
      return <BeehiivFields editor={editor} setEditor={setEditor} />;
    case "buttondown":
      return <ButtondownFields editor={editor} setEditor={setEditor} />;
    // bluesky/mastodon retired 2026-07-03.
    default:
      return (
        <EmailFields
          editor={editor}
          setEditor={setEditor}
          addRecipientFromDraft={props.addRecipientFromDraft}
          removeRecipient={props.removeRecipient}
        />
      );
  }
};
